import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getCardModule } from 'helpers/offer.helpers';
import { useComplexState } from 'hook/helper.hook';
import { getOffersRequestParameters } from 'helpers/offer.helpers';
import { fetchOffers } from 'externals/_services/personalization.service';
import { wrapService } from 'actions/service_wrapper.actions';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import {
  CASH_BACK,
  CATEGORY_FILTERS,
  HIGHEST_APPROVAL_ODDS,
  SUGGESTED,
  TRAVEL,
  PRE_APPROVED_CARDS,
  BUSINESS,
} from 'types/cardsOffersFilters.constants';
import {
  CREDIT_CARD_CATEGORY_CONTAINER,
  CREDIT_CARD_CONTAINER,
} from 'partial/OfferManager/offer.constants';
import { getKeyByValue } from 'helpers/common';
import {
  LIST_FILTERS,
  LIST_FILTER_ABOVE650,
} from 'types/cardsOffersFilters.constants';

export const useCreditCardCategories = props => {
  const updatedListFilter = props?.config?.credit_card?.isShowBusinessFilterCC
    ? LIST_FILTERS
    : LIST_FILTERS?.filter(item => item !== BUSINESS);
  const updatedListFilterAbove650 = props?.config?.credit_card
    ?.isShowBusinessFilterCC
    ? LIST_FILTER_ABOVE650
    : LIST_FILTER_ABOVE650?.filter(item => item !== BUSINESS);
  const dispatch = useDispatch();
  const [state, setState] = useComplexState({
    selectedCategory:
      props?.creditInfo?.creditScore >= 650 ? SUGGESTED : HIGHEST_APPROVAL_ODDS,
    isLoadingChangueCategory: false,
    cardCategoriesOffers: null,
    cardCategoriesContainerLoading: false,
    CATEGORY_FILTER:
      props?.creditInfo?.creditScore >= 650 ? updatedListFilterAbove650 : '',
    userSelectedCategory: true,
  });
  const getHighestApprovalOddsOffers = (
    creditCardCategoriesContainer,
    moduleContainer,
  ) => {
    const module = getCardModule(
      creditCardCategoriesContainer,
      moduleContainer,
    );
    return module ? module?.offers : [];
  };

  const a_fetchCreditCardCategories = wrapService(fetchOffers, {
    name: 'fetchCreditCardCategories',
  });

  const loadCreditCardCategoriesContainer =
    (moduleContainer, isCreditCardContainer, creditInfoArg, doNotClear) =>
    (dispatch, getState) => {
      if (!doNotClear) {
        setState({
          cardCategoriesContainerLoading: true,
        });
      }

      const container = isCreditCardContainer
        ? CREDIT_CARD_CONTAINER
        : CREDIT_CARD_CATEGORY_CONTAINER;

      const paramsFromFlag = getOffersRequestParameters();
      return new Promise((resolve, reject) => {
        let queryParams = {
          moduleNames: moduleContainer,
          prescreen: true,
          rankingType: paramsFromFlag?.rankingType,
          vriVersion: 'click',
          guaranteeBadge: paramsFromFlag?.guaranteeBadge,
          approvalOddsBadgeOverride: paramsFromFlag?.approvalOddsBadgeOverride,
          cciVersion: paramsFromFlag?.cciVersion,
        };
        dispatch(a_fetchCreditCardCategories(container, queryParams))
          .then(res => {
            setState({
              cardCategoriesContainerLoading: false,
              cardCategoriesOffers: getHighestApprovalOddsOffers(
                res,
                moduleContainer,
              ),
              ...(state?.userSelectedCategory &&
              moduleContainer === PRE_APPROVED_CARDS &&
              res?.modules?.length === 0
                ? { selectedCategory: SUGGESTED }
                : {}),
              ...(state?.userSelectedCategory &&
              moduleContainer === PRE_APPROVED_CARDS &&
              res?.modules?.length === 0
                ? { CATEGORY_FILTER: updatedListFilterAbove650 }
                : {}),
              ...(state?.userSelectedCategory &&
              moduleContainer === PRE_APPROVED_CARDS &&
              res?.modules?.length > 0
                ? {
                    CATEGORY_FILTER: updatedListFilter,
                    selectedCategory: HIGHEST_APPROVAL_ODDS,
                  }
                : {}),
            });
          })
          .catch(err => {
            setState({
              cardCategoriesContainerLoading: false,
              cardCategoriesOffers: null,
            });
          });
      });
    };

  const getContainerData = () => {
    let isCreditCardContainer = false;
    const isSuggestedCategory = state?.selectedCategory === SUGGESTED;
    if (
      state?.selectedCategory === TRAVEL ||
      state?.selectedCategory === CASH_BACK
    ) {
      isCreditCardContainer = true;
    }
    if (!isSuggestedCategory) {
      dispatch(
        loadCreditCardCategoriesContainer(
          getKeyByValue(CATEGORY_FILTERS, state?.selectedCategory),
          isCreditCardContainer,
        ),
      );
    }
  };

  const onChangeCategory = selectedCategory => {
    const clickType = selectedCategory;
    props.eventHandler(CLICK, {
      'Click Type': clickType,
    });
    setState({
      selectedCategory: selectedCategory,
      cardCategoriesOffers: null,
      userSelectedCategory: false,
    });
  };

  useEffect(() => {
    if (!state.cardCategoriesOffers) {
      getContainerData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.cardCategoriesOffers, state?.selectedCategory]);

  const containerType = getKeyByValue(
    CATEGORY_FILTERS,
    state?.selectedCategory,
  );
  return {
    onChangeCategory,
    containerType,
    ...state,
  };
};
